import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XmCodeComponent } from './xm-code.component';

@NgModule({
    imports: [CommonModule],
    exports: [XmCodeComponent],
    declarations: [XmCodeComponent],
})
export class XmCodeModule {
}
